import { Footer, FooterSection } from '@rover/rsdk/src/apiClient/latest';

export const defaultFooterSection: FooterSection = {
  name: '',
  visible: false,
  items: [],
};

export const defaultFooter: Footer = {
  learnMore: defaultFooterSection,
  rspcaCallout: false,
  helpLinks: defaultFooterSection,
  aboutRover: defaultFooterSection,
  emailCapture: defaultFooterSection,
  visitBlog: defaultFooterSection,
  marketingSocial: defaultFooterSection,
  europeCountries: defaultFooterSection,
};

export default function footerFactory(footer?: Partial<Footer>): Footer {
  return { ...defaultFooter, ...footer };
}
